
import { mapActions, mapState } from 'vuex'
const Mixin = {
  methods: {
    ...mapActions(['Login', 'getMapInfo', 'getHistoryDeviceLog', 'getDevType', 'getAllBig'])
  },
  computed: {
    ...mapState({
      MapInfoWL: state => state.moduleWL.MapInfo,
      HistorydeviceLogWL: state => state.moduleWL.HistorydeviceLog,
      DevType: state => state.moduleWL.DevType,
      AllBig: state => state.moduleWL.AllBig
    })
  }
}
export default Mixin
